import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { ChargeAutomationOverlayComponent } from './automations/overlay/charge-automation-overlay.component'
import { ChargesLibraryModule } from '@tokeet-frontend/charges'
import { ChargeDialogComponent } from './charges/dialogs/charge-dialog/charge-dialog.component'
import { ChargeDialogService } from './charges/dialogs/charge-dialog/charge-dialog.service'
import { AiResponderSharedModule } from '@tv3/containers/ai-responder/ai-responder-shared.module'

const components = [
  //
  ChargeAutomationOverlayComponent,
  ChargeDialogComponent,
]

const services = [ChargeDialogService]

const modules = [SharedModule, ChargesLibraryModule, AiResponderSharedModule]

@NgModule({
  declarations: [...components],
  imports: [CommonModule, ...modules],
  exports: [...components, ...modules],
  providers: [...services],
})
export class ChargesSharedModule {}
